import PageBrand from '@components/common/PageBrand'
import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { useHistory } from 'react-router-dom'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'
import BackgroundAnimation from '../components/common/BackgroundAnimation'
import { GlassCard } from '@components/common/Glass'

export default function Privacy(): JSX.Element {
  const history = useHistory()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div>
      <BackgroundAnimation />
      <Container
        sx={{
          pb: 6,
          minHeight: '100vh',
          px: { xs: 1, sm: 3 },
          mt: { xs: 2, sm: 4 },
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
        maxWidth="md"
      >
        <PageBrand />
        <GlassCard
          sx={{
            width: '100%',
            textAlign: 'left',
            p: { xs: 2.5, sm: 3.5 },
            borderRadius: '32px',
            borderColor: 'rgba(255,255,255,0.7)',
            boxShadow: '0 3px 0 #e0eaf2, 0 8px 18px #1c3b5709',
          }}
        >
          <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <IconButton onClick={() => history.goBack()}>
                <ArrowBackIosNewRoundedIcon fontSize="small" sx={{ mr: 0.25 }} />
              </IconButton>
              <Box />
            </Box>
            <Typography variant={fullScreen ? 'h4' : 'h3'} fontWeight={600}>
              Privacy Policy
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1}>
              RankTrivia (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) operates the
              RankTrivia website and mobile app (the &quot;Service&quot;), a trivia and ranking
              game.
            </Typography>

            <Typography variant="body2" color="#444" mt={1}>
              This Privacy Policy explains what information we collect, how we use it, and the
              choices you have. By using the Service, you agree to this policy.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Information We Collect
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We collect information you provide when you create an account, such as email and a
              username. If you choose a social login, we may receive a unique identifier and basic
              profile information from that provider.
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We also collect gameplay data you generate (for example, lists you create, rankings,
              submissions, or scores) to provide and improve the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Log Data &amp; Device Information
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              When you use the Service, we may collect standard log data such as IP address, device
              type, browser version, pages viewed, and timestamps. This helps us operate, secure,
              and improve the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Cookies
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We use cookies and similar technologies to keep you signed in, remember preferences,
              and understand usage. You can choose to disable cookies in your browser settings,
              though some parts of the Service may not function properly.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              How We Use Information
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We use information to operate the Service, personalize your experience, improve game
              features, prevent abuse, and communicate important updates.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Sharing &amp; Service Providers
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We may use trusted third-party services for hosting, analytics, or authentication.
              These providers are permitted to access information only to perform services on our
              behalf and are required to protect it.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Security
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We take reasonable measures to protect your information, but no method of transmission
              or storage is 100% secure.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Children&apos;s Privacy
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              The Service is not directed to children under 13. We do not knowingly collect personal
              information from children under 13. If you believe a child has provided us
              information, please contact us so we can remove it.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Your Choices &amp; Account Deletion
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              You can access and update your account settings in the app. You may request deletion
              of your account at any time from the Account page.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Changes To This Policy
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We may update this Privacy Policy from time to time. Updates will be posted on this
              page and are effective when posted.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Contact Us
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              If you have any questions, contact us at{' '}
              <a
                href="mailto:info@teamautomate.com"
                style={{
                  color: '#53d9f5',
                  fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                info@teamautomate.com
              </a>
              .
            </Typography>
          </Box>
        </GlassCard>
      </Container>
    </div>
  )
}
